<template>
    <div style="min-width: 220px;">
        <div class="popper-title">标签-选择</div>
        <div class="popper-input">
            <el-input v-model="name" placeholder="请输入内容">
                <i slot="suffix" class="el-input__icon el-icon-search" @click="getBizTagList"></i>
            </el-input>
        </div>
        <div class="simple-list">
            <div class="simple-item active" v-for="(bizTag, index) in bizTagList" @click="doSelect(bizTag)">
                <a>{{ bizTag.name }}</a>
                <i v-if="selectIdsX.contains(bizTag.id)" class="icon iconfont icon-success"></i>
                <i class="icon iconfont" v-else></i>
            </div>
        </div>
        <div class="popper-btn-group">
            <el-button type="primary" size="mini" @click="doConfirm">确定</el-button>
            <el-button size="mini" @click="doCancel">取消</el-button>
        </div>
    </div>
</template>

<script>
    import {Utilsx, $} from '../../app.base'
    import {Vue, MsgBox, Routes, DomSizeWatcher, getComnMerchantBizTag} from '../../app.vues'

    import {getDefaultPageSizes} from '../../app.conf'

    import retailerApi from '../../api/retailer'

    export default {
        name: 'swb-biz-tag-list-for-select',
        desc: '业务标签选择',
        props: {
            bizAspect: {
                type: Number,
                default: null
            },
            selectIds: {
                type: Array,
                default: []
            },
            checkBox: { // 是否多选
                type: Boolean,
                default: true
            }
        },
        data: function () {
            return {
                // 分页信息
                pageNumber: 1,
                totalCount: 0,
                pageSize: null,
                pageSizes: getDefaultPageSizes(),
                // 过滤信息
                queryModel: {
                    filterItems: {},
                    sortItemList: [],
                    sortItems: {}
                },
                // 其他信息
                bizTagList: [],
                selectIdsX: [],
                selectBizTagList: [],
                name: null,
            }
        },
        created: function () {
            this.pageSize = this.pageSizes.first();
            this.getBizTagList();
        },
        watch: {
            selectIds(newVal, oldVal) {
                if (oldVal != newVal) {
                    let selectIds = newVal || [];
                    let selectBizTagList = [];
                    selectIds.forEach(function (id) {
                        let selectBizTag = {
                            id: id
                        };
                        selectBizTagList.push(selectBizTag);
                    });
                    this.selectBizTagList = Utils.merge([], selectBizTagList);
                    this.selectIdsX = Utils.merge([], selectIds);
                }
            },
        },
        methods: {
            //
            getBizTagList() {
                let self = this;
                //
                let filter = {};
                filter.bizAspect = this.bizAspect;
                if (!Utils.isNoB(this.name)) {
                    filter.name = this.name;
                }
                let comnBizTag = getComnMerchantBizTag();
                //
                comnBizTag.getBizTagListByBizAspect(filter, function (bizTagList) {
                    self.bizTagList = bizTagList || [];
                });
            },
            doSelect: function (bizTag) {
                let selectBizTagList = this.selectBizTagList || [];
                let selectIdsX = selectBizTagList.pluck("id") || [];
                if (this.checkBox) {
                    // 默认多选
                    if (!selectIdsX.contains(bizTag.id)) {
                        if (!Utils.isNoB(selectIdsX) && selectIdsX.length == 5) {
                            Toast.show("最多可选择5个标签！", 1000, 'warning');
                            return false;
                        }
                        selectBizTagList.push(bizTag);
                        selectIdsX.push(bizTag.id);
                    } else {
                        for (let i = 0; i < selectBizTagList.length; i++) {
                            let selectBizTag = selectBizTagList[i];
                            if (selectBizTag.id == bizTag.id) {
                                selectBizTagList.splice(i, 1);
                                i--;
                                break;
                            }
                        }
                        selectIdsX = selectBizTagList.pluck("id") || [];
                    }
                } else {
                    // 单选
                    selectBizTagList = [];
                    selectIdsX = [];
                    selectBizTagList.push(bizTag);
                    selectIdsX.push(bizTag.id);
                }
                this.selectBizTagList = Utils.merge([], selectBizTagList);
                this.selectIdsX = Utils.merge([], selectIdsX);
            },
            doConfirm: function () {
                let bizTagList = this.selectBizTagList;
                this.selectIdsX = [];
                this.selectIds = [];
                let selectBizTagList = [];
                this.selectBizTagList = Utils.merge([], selectBizTagList);
                this.$emit('notity-bizTag-comfirm', bizTagList);
            },
            doCancel: function () {
                this.selectIdsX = [];
                this.selectIds = [];
                let selectBizTagList = [];
                this.selectBizTagList = Utils.merge([], selectBizTagList);
                this.$emit('notity-bizTag-cancel');
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/compo/bizTag/BizTagListForSelect.vue